import GroupRegRegionPicker from './GroupRegRegionPicker';

export default GroupRegRegionPicker;
